import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VmAction } from 'src/app/enums/vm_action.enum';
import { HttpService } from 'src/app/http.service';
import { VirtualMachineDeletionRequest, VMCreationRequest } from 'src/app/interfaces/vm.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VirtualMachineService {

  totalVms: number = 0

  constructor(private http: HttpService) { }

  deleteVms(selectedServer:VirtualMachineDeletionRequest): Observable<Map<string, string>> {
    return this.http.post(environment.api.routes.environment.delete_vm, selectedServer);
  }

  restoreVms(envName: string, subId: string, vmIds: number[]): Observable<string> {
    // var requestBody = {
    //   EnvName: envName,
    //   SubscriptionId: subId,
    //   VmIds: vmIds
    // }
    // return this.http.post(environment.api.routes.vms.restore, requestBody);

    // Dummy response
    return of('VMs restored successfully');
  }

  vmActions(action: VmAction, vmIds: number[], envName: string, subscriptionId: string): Observable<string> {
    // var requestBody = {
    //   SubscriptionId: subscriptionId,
    //   EnvName: envName,
    //   VmIds: vmIds,
    // };
    // switch(action) {
    //   case VmAction.start:
    //     return this.http.post(environment.api.routes.vms.start_vm, requestBody);
    //   case VmAction.stop:
    //     return this.http.post(environment.api.routes.vms.stop_vm, requestBody);
    //   case VmAction.restart:
    //     return this.http.post(environment.api.routes.vms.restart_vm, requestBody);
    // }

    // Dummy response based on action
    switch(action) {
      case VmAction.start:
        return of('VMs started successfully');
      case VmAction.stop:
        return of('VMs stopped successfully');
      case VmAction.restart:
        return of('VMs restarted successfully');
    }
  }

  createVMs(data: VMCreationRequest){
    return this.http.post<string>(environment.api.routes.environment.create_vm, data);
  }

  retryCreateVM(data){
    return this.http.post<string>(environment.api.routes.environment.retry_create_vm, data);
  }
}
